import { createStore } from 'store-utils';
import { Channel } from '../types/slack-types';
import { Nullable } from 'common-types';

const SlackStore = createStore<SlackState>(
  {
    loadingSubmit: false,
    loadingSlackChannels: false,
    publicChannels: null,
    fields: {
      selectedChannel: null,
      userComment: '',
    },
  },
  'Slack Store',
);

interface SlackState {
  publicChannels: Nullable<Channel[]>;
  loadingSubmit: boolean;
  loadingSlackChannels: boolean;
  fields: {
    selectedChannel: Nullable<Channel>;
    userComment: string;
  };
}

export default SlackStore;
